import React, { Component, useLayoutEffect, useRef, useState } from "react";
import { gsap } from "gsap";

const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);

class CloudMachine extends Component {
  render() {
    return (
      <div className="cloudMachine">
        <LongCloud1
          classProp={"cloudTest"}
          width={"300"}
          //height={"50%"}
          innerWidth={window.innerWidth}
        />
      </div>
    );
  }
}

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  console.log(size);
  return size;
}

function LongCloud1({ classProp, width, innerWidth }) {
  const cloud = useRef();
  const circle = useRef();
  const [windowWidth, windowHeight] = useWindowSize();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        ".cloud",
        {
          right: -(width * rem + 100),
        },
        {
          right: windowWidth + 1,
          duration: 20,
          repeat: -1, //-1
          ease: "none",
          repeatDelay: 2,
          repeatRefresh: true,
        }
      );
    }, cloud); // <- Scope!

    return () => ctx.revert();
  }, [width, windowWidth]);

  return (
    <div ref={cloud}>
      <svg
        width={width + "rem"}
        //height={width}
        version="1.1"
        viewBox="0 0 243.218 30"
        xmlns="http://www.w3.org/2000/svg"
        /* fill="currentColor" */ className={"cloud " + classProp}>
        <defs>
          <linearGradient id="sunray" x1="0.5" y1="0" x2="0.5" y2="1">
            <stop offset="0%" stopColor="#fff930" />
            <stop offset="38%" stopColor="#ff9a00" />
            <stop offset="82%" stopColor="#ff515a" />
            <stop offset="100%" stopColor="#ff00bd" />
          </linearGradient>
        </defs>
        <g transform="translate(-2.6064 -90)" fill="url(#sunray)">
          <path d="m 7.6066116,89.999824 c -2.7699916,0 -5.0002116,2.23021 -5.0002116,5.00021 0,2.77 2.23022,5.000206 5.0002116,5.000206 H 11.56761 v -5.06e-4 h 8.540564 c 0.0035,0 0.0068,5.06e-4 0.01033,5.06e-4 h 19.474264 v 5.2e-4 h 10.972974 c 2.715694,0 4.902026,2.18633 4.902026,4.90203 v 0.19585 c 0,2.7086 -2.175045,4.89011 -4.880839,4.90151 H 28.328861 c -2.769994,0 -4.999695,2.2297 -4.999695,4.9997 0,2.76999 2.229701,5.00021 4.999695,5.00021 H 177.65876 c 2.77,0 5.00022,-2.23022 5.00022,-5.00021 0,-2.77 -2.23022,-4.9997 -5.00022,-4.9997 h -1.57509 c -2.7608,-0.0106 -4.98058,-2.2363 -4.98058,-4.9997 0,-2.76998 2.23023,-4.99969 5.00021,-4.99969 h 4.1057 v -5.2e-4 h 51.27542 c 2.77,0 5.00021,-2.230206 5.00021,-5.000206 0,-2.77 -2.23021,-5.00021 -5.00021,-5.00021 h -91.0053 c -2.77,0 -5.00021,2.23021 -5.00021,5.00021 0,2.77 2.23021,5.000206 5.00021,5.000206 h -9.05009 v 5.2e-4 H 142.402 c 2.7156,0 4.90203,2.18633 4.90203,4.90203 v 0.19585 c 0,2.7086 -2.17504,4.89011 -4.88084,4.90151 H 84.246378 c -2.760794,-0.0106 -4.980575,-2.2363 -4.980575,-4.9997 0,-2.76998 2.230218,-4.99969 5.000212,-4.99969 h 4.105693 v -5.2e-4 h 22.752102 c 2.76998,0 5.00021,-2.230206 5.00021,-5.000206 0,-2.77 -2.23023,-5.00021 -5.00021,-5.00021 H 21.675004 20.118509 11.56761 11.467358 Z M 210.02888,110.00015 c -2.77,0 -5.00021,2.2297 -5.00021,4.9997 0,2.76999 2.23021,5.00021 5.00021,5.00021 h 13.38316 c 2.77,0 4.9997,-2.23022 4.9997,-5.00021 0,-2.77 -2.2297,-4.9997 -4.9997,-4.9997 z m 27.56473,0 c -2.77,0 -5.00021,2.2297 -5.00021,4.9997 0,2.76999 2.23021,5.00021 5.00021,5.00021 h 3.23081 c 2.76998,0 4.99969,-2.23022 4.99969,-5.00021 0,-2.77 -2.22971,-4.9997 -4.99969,-4.9997 z" />
          {/** 
          <path d="m15.817 90c-2.77 0-4.9997 2.2302-4.9997 5.0002 0 2.77 2.2297 4.9997 4.9997 4.9997h22.258c2.7058 0.011404 4.8808 2.1929 4.8808 4.9015v0.19585c0 2.7157-2.1863 4.902-4.902 4.902h-10.973v5.1e-4h-19.474c-2.77 0-5.0002 2.2302-5.0002 5.0002 0 2.77 2.2302 5.0002 5.0002 5.0002h91.005c2.77 0 5.0002-2.2302 5.0002-5.0002 0-2.77-2.2302-5.0002-5.0002-5.0002h-22.752v-5.1e-4h-4.1057c-2.77 0-5.0002-2.2297-5.0002-4.9997 0-2.7634 2.2198-4.9891 4.9806-4.9997h58.177c2.7058 0.011404 4.8808 2.1929 4.8808 4.9015v0.19585c0 2.7157-2.1864 4.902-4.902 4.902h-10.973v5.1e-4h9.0501c-2.77 0-5.0002 2.2302-5.0002 5.0002 0 2.77 2.2302 5.0002 5.0002 5.0002h91.005c2.77 0 5.0002-2.2302 5.0002-5.0002 0-2.77-2.2302-5.0002-5.0002-5.0002h-51.275v-5.1e-4h-4.1057c-2.77 0-5.0002-2.2297-5.0002-4.9997 0-2.7634 2.2198-4.9891 4.9806-4.9997h1.5751c2.77 0 5.0002-2.2297 5.0002-4.9997 0-2.77-2.2302-5.0002-5.0002-5.0002h-149.33zm181.7 0c-2.77 0-5.0002 2.2302-5.0002 5.0002 0 2.77 2.2302 4.9997 5.0002 4.9997h13.383c2.77 0 4.9997-2.2297 4.9997-4.9997 0-2.77-2.2297-5.0002-4.9997-5.0002h-13.383zm27.565 0c-2.77 0-5.0002 2.2302-5.0002 5.0002 0 2.77 2.2302 4.9997 5.0002 4.9997h3.2308c2.77 0 4.9997-2.2297 4.9997-4.9997 0-2.77-2.2297-5.0002-4.9997-5.0002h-3.2308z" />
          */}
        </g>
      </svg>
    </div>
  );
}

export default CloudMachine;
